/* eslint-disable import/no-unresolved */
import React from "react";
import ShopOrderDetail from "components/pages/user/orders/ShopOrderDetail";
import WholesaleHeaderNav from "components/elements/main/WholesaleHeaderNav";

const WholesaleUserOrderDetail = (props) => {

    return (
        <div>
            <WholesaleHeaderNav {...props} />
            <ShopOrderDetail {...props} wholesale={true} />
        </div>
    );
};

export default (WholesaleUserOrderDetail);
